import {Button, Modal} from "react-bootstrap";
import useTranslation from "../../hooks/translations";

export default function ConfirmationModal({
                                            data,
                                            showModal,
                                            title,
                                            message,
                                            onConfirmationModalSubmit,
                                            onConfirmationModalClose
                                          }) {
  const translations = useTranslation();

  const handleClose = () => {
    onConfirmationModalClose()
  };

  const handleSubmit = () => {
    onConfirmationModalSubmit(data)
  };

  const dialogTitle = title ? title : translations.confirmationModalTitle;
  const dialogMessage = message ? message : translations.confirmationModalMessage;

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{dialogTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{dialogMessage}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>
          {translations.yes}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          {translations.close}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
